<template>
  <div class="page document-audit">
    <div class="content-box">
       <div class="content-left" >
          <div class="content-title" >
            文档版本: {{versionComparefDocument.newVersionName}}
          </div>
          <el-scrollbar ref="view-box" style="position: relative;flex: 1;height:100%;">
            <div class="view-box">
              <div class="html" v-html="versionComparefDocument.new"></div>
            </div>
          </el-scrollbar>
       </div>
       <div class="content-right">
          <div class="content-title">
            文档版本: {{versionComparefDocument.oldVersionName}}
          </div>
          <el-scrollbar ref="view-box" style="position: relative;flex: 1;height:100%;">
            <div class="view-box">
              <div class="html" v-html="versionComparefDocument.old"></div>
            </div>
          </el-scrollbar>
       </div>
    </div>
    <div class="foot">
      <el-button class="w150" type="primary" @click="onCancel()">返回</el-button>
    </div>
  </div>
</template>

<script>
import store from '@/store/index.js';

export default {
  data() {
    return {
      versionComparefDocument:'',
    }
  },
  mounted(){
    this.versionComparef()
  },
  methods:{
    versionComparef(){
      this.$apis.documentServer.versionComparefDocument({
        type :this.$route.query.type,//	string	type
        docMenuId:this.$route.query.docMenuId,//	string	docMenuId
        id:this.$route.query.id,//	string	id
      })
      .then((res) => {
        if (res.code == 0) {
          this.versionComparefDocument = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onCancel() {
      this.$router.go(-1)
    },
  }
}
</script>

<style  lang="scss">
  .document-audit{
    margin-top: 20px;
    padding: 26px 23px;
    border-radius: 5px;
    background-color: #fff;
    .content-box{
      display: flex;
      margin-bottom: 20px;
      .content-title{
        padding-left: 17px;
        line-height: 43px;
        background: #28262C;
        font-size: 16px;
        font-weight: bold;
        color: #E7DCAE;
      }
      .view-box{
        position: relative;
        height:   810px;
        background: #Fff;
        .html{
          padding: 60px;
          .Right{
            background: #fe9;
          }
          ins{
            background: red;
          }
          del{
            display: block;
            background: #fd8;
            text-decoration-line: blink;
          }
          img{
            max-width: 100%;
          }
          html, address,blockquote,body, dd, div,dl, dt, fieldset, form,frame, frameset,h1, h2, h3, h4,h5, h6, noframes,ol, p, ul, center,dir, hr, menu, pre   { display: block; unicode-bidi: embed }li              { display: list-item }head            { display: none }table           { display: table }tr              { display: table-row }thead           { display: table-header-group }tbody           { display: table-row-group }tfoot           { display: table-footer-group }col             { display: table-column }colgroup        { display: table-column-group }td, th          { display: table-cell }caption         { display: table-caption }th              { font-weight: bolder; text-align: center }caption         { text-align: center }body            { margin: 8px }h1              { font-size: 2em; margin: .67em 0 }h2              { font-size: 1.5em; margin: .75em 0 }h3              { font-size: 1.17em; margin: .83em 0 }h4, p,blockquote, ul,fieldset, form,ol, dl, dir,menu            { margin: 1.12em 0 }h5              { font-size: .83em; margin: 1.5em 0 }h6              { font-size: .75em; margin: 1.67em 0 }h1, h2, h3, h4,h5, h6, b,strong          { font-weight: bolder }blockquote      { margin-left: 40px; margin-right: 40px }i, cite, em,var, address    { font-style: italic }pre, tt, code,kbd, samp       { font-family: monospace }pre             { white-space: pre }button, textarea,input, select   { display: inline-block }big             { font-size: 1.17em }small, sub, sup { font-size: .83em }sub             { vertical-align: sub }sup             { vertical-align: super }table           { border-spacing: 2px; }thead, tbody,tfoot           { vertical-align: middle }td, th, tr      { vertical-align: inherit }s, strike,hr              { border: 1px inset }ol, ul, dir,menu, dd        { margin-left: 40px }ol              { list-style-type: decimal }ol ul, ul ol,ul ul, ol ol    { margin-top: 0; margin-bottom: 0 }u, ins          { text-decoration: underline }br:before       { content: "\A"; white-space: pre-line }center          { text-align: center }:link, :visited { text-decoration: underline }:focus          { outline: thin dotted invert }/* Begin bidirectionality settings (do not change) */BDO[DIR="ltr"]  { direction: ltr; unicode-bidi: bidi-override }BDO[DIR="rtl"]  { direction: rtl; unicode-bidi: bidi-override }*[DIR="ltr"]    { direction: ltr; unicode-bidi: embed }*[DIR="rtl"]    { direction: rtl; unicode-bidi: embed }@media print {
          h1            { page-break-before: always }

          h1, h2, h3,

          h4, h5, h6    { page-break-after: avoid }

          ul, ol, dl    { page-break-before: avoid }}
          pre[class*="language-"]{
            border:0;
            box-shadow:none;
          }
        }
      }
      .content-left{
        flex: 1;
        border: 1px solid #DFDFDF;
        border-radius: 5px;
        overflow: hidden;
      }
      .content-right{
        margin-left: 20px;
        flex: 1;
        border: 1px solid #DFDFDF;
        border-radius: 5px;
        overflow: hidden;
      }
    }
    .foot {
      margin-top: 20px;
      text-align: center;
    }
  }
</style>